import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    mutation ($email: String!, $origin: String!, $codeEntryMode: Boolean) {\n        resendVerifyAccount(email: $email, origin: $origin, codeEntryMode: $codeEntryMode) {\n            ok\n            errors {\n                path\n                message\n            }\n        }\n    }  \n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    mutation ($token: String!, $planCode: String!, $email: String) {\n        setSubscriptionLevelByCode(token: $token, planCode: $planCode, email: $email) {\n            ok\n            email\n            errors {\n                path\n                message\n            }\n        }\n    }  \n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    query ($code: String!) {\n        getSubscriptionLevelByCode(code: $code) {\n            code\n            name\n            monthlyCostFormatted\n        }\n    } \n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import _ from 'lodash';
import { NewAccountForm } from '@emyw/auth-lib';
import { Header, Divider, Message, Dimmer, Loader, Transition } from 'semantic-ui-react';
import gql from 'graphql-tag'; // import { compose, graphql } from 'react-apollo';

import { AccountClient, AuthClient, log } from '@emyw/core-lib';
import { normalizeErrors, getRootUrl, getPlanCostLabel } from '../utils';
import '../custom-theme.css';
var _process$env = process.env,
    FREE = _process$env.REACT_APP_FREE_PLAN_CODE,
    PREMIUM = _process$env.REACT_APP_PREMIUM_PLAN_CODE,
    REACT_APP_SKIP_EMAIL_VERIFICATION = _process$env.REACT_APP_SKIP_EMAIL_VERIFICATION;
var getSubscriptionLevelByCodeQuery = gql(_templateObject());
var setSubscriptionLevelByCodeMutation = gql(_templateObject2());
var resendVerifyAccountMutation = gql(_templateObject3());

var Step2CreateAccount = /*#__PURE__*/function (_React$Component) {
  _inherits(Step2CreateAccount, _React$Component);

  var _super = _createSuper(Step2CreateAccount);

  function Step2CreateAccount() {
    var _this;

    _classCallCheck(this, Step2CreateAccount);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      formComplete: _this.props.forceComplete,
      processing: false,
      defaultPlan: undefined,
      errors: [],
      trace: []
    };

    _this.handleTermsClick = function () {
      return _this.props.onTermsClick();
    };

    _this.handlePrivacyClick = function () {
      return _this.props.onPrivacyClick();
    };

    _this.handleComplete = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, token) {
        var trace, _this$props, planCode, onFormSubmittedPendingValidation, selectedPlanCode, response, _response$data$setSub, ok, email, errors;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                trace = _this.state.trace;
                _context.prev = 1;

                // trace.push('setting subscription level...');
                _this.setState({
                  processing: true,
                  trace: trace
                });

                _this$props = _this.props, planCode = _this$props.planCode, onFormSubmittedPendingValidation = _this$props.onFormSubmittedPendingValidation;
                if (onFormSubmittedPendingValidation) onFormSubmittedPendingValidation(values);
                selectedPlanCode = !planCode ? FREE : planCode;
                _context.next = 8;
                return AccountClient.mutate({
                  mutation: setSubscriptionLevelByCodeMutation,
                  variables: {
                    token: token,
                    planCode: selectedPlanCode,
                    email: values.email
                  }
                });

              case 8:
                response = _context.sent;
                _response$data$setSub = response.data.setSubscriptionLevelByCode, ok = _response$data$setSub.ok, email = _response$data$setSub.email, errors = _response$data$setSub.errors;

                if (ok) {
                  // great! we've got an unverified user created on the server and the subscription level set.
                  // The server conveniently returned the email. We'll tell the server to send a verification email.
                  // trace.push('subscription level set');
                  _this.setState({
                    trace: trace
                  });

                  _this.verifyAccountEmail(values, email);
                } else {
                  // trace.push(`setSubscriptionLevelByCode: ${errors}`);
                  log.trace("setSubscriptionLevelByCode: ".concat(errors));

                  _this.setState({
                    errors: normalizeErrors(errors, 'general', true),
                    processing: false,
                    trace: trace
                  });
                }

                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](1);
                trace.push("handleComplete: ".concat(_context.t0));
                log.trace("handleComplete: ".concat(_context.t0));

                _this.setState({
                  errors: [_context.t0.message],
                  processing: false,
                  trace: trace
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 13]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.verifyAccountEmail = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(values, email) {
        var trace, onFormComplete, response, _response$data$resend, ok, errors;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                trace = _this.state.trace;
                _context2.prev = 1;
                log.trace("Verify Email: ".concat(email)); // trace.push('verifying account email...');

                _this.setState({
                  trace: trace
                });

                onFormComplete = _this.props.onFormComplete;
                _context2.next = 7;
                return AuthClient.mutate({
                  mutation: resendVerifyAccountMutation,
                  variables: {
                    email: email,
                    origin: getRootUrl(),
                    codeEntryMode: !REACT_APP_SKIP_EMAIL_VERIFICATION
                  }
                });

              case 7:
                response = _context2.sent;
                _response$data$resend = response.data.resendVerifyAccount, ok = _response$data$resend.ok, errors = _response$data$resend.errors; // log.trace(`Verify Email: ${email} -  ${onFormComplete} - ${values}`);

                if (ok) {
                  // trace.push('account email verified');
                  if (onFormComplete) onFormComplete(values);else _this.setState({
                    formComplete: true,
                    processing: false,
                    trace: trace
                  });
                } else {
                  // trace.push('account email errors');
                  log.trace(errors);

                  _this.setState({
                    errors: normalizeErrors(errors, 'general', true),
                    processing: false,
                    trace: trace
                  });
                }

                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](1);
                // trace.push(`verifyAccountEmail: ${error}`);
                log.trace("verifyAccountEmail: ".concat(_context2.t0));

                _this.setState({
                  errors: [_context2.t0.message],
                  processing: false,
                  trace: trace
                });

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 12]]);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.handleUserAlreadyExists = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(code, values, token) {
        var trace, onFormComplete;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                trace = _this.state.trace; // trace.push(`handleUserAlreadyExists ${code}`, token);

                _this.setState({
                  trace: trace
                });

                onFormComplete = _this.props.onFormComplete; // Here we handle some specific scenarios where the user tried to register with an email that already existed.

                _context3.t0 = code;
                _context3.next = _context3.t0 === 'not_verified' ? 6 : _context3.t0 === 'exists_authenticated' ? 8 : _context3.t0 === 'incorrect_password' ? 10 : 12;
                break;

              case 6:
                // this will resend the verification email
                _this.handleComplete(values, token);

                return _context3.abrupt("break", 13);

              case 8:
                // the user tried to register an existing email and they even provided the correct password.
                // In this case, we need to figure out where they are at in the signup process and decide where
                // to send them next
                if (onFormComplete) onFormComplete(null
                /* , await this.signupStatus(values.email) */
                );
                return _context3.abrupt("break", 13);

              case 10:
                // The email was already in the system and the user provided an incorrect password.
                // Show a message to the user that this email is already registered and give them the option
                // to sign in.
                _this.setState({
                  errors: ['You\'ve entered an email address that is already registered with Enjoy.' + ' If you are or were a member please click "Sign In".'],
                  processing: false
                });

                return _context3.abrupt("break", 13);

              case 12:
                _this.setState({
                  errors: ["Unknown error code: ".concat(code)],
                  processing: false
                });

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x5, _x6, _x7) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.getDefaultPlan = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var response, getSubscriptionLevelByCode;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return AccountClient.query({
                query: getSubscriptionLevelByCodeQuery,
                variables: {
                  code: PREMIUM
                },
                fetchPolicy: 'network-only'
              });

            case 2:
              response = _context4.sent;
              getSubscriptionLevelByCode = response.data.getSubscriptionLevelByCode;

              _this.setState({
                defaultPlan: getSubscriptionLevelByCode
              }); // const { name, monthlyCostFormatted } = getSubscriptionLevelByCode;


            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _this;
  }

  _createClass(Step2CreateAccount, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var planSelectDisabled = this.props.planSelectDisabled;
      if (planSelectDisabled) this.getDefaultPlan();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          formComplete = _this$state.formComplete,
          processing = _this$state.processing,
          defaultPlan = _this$state.defaultPlan,
          errors = _this$state.errors,
          trace = _this$state.trace;
      var _this$props2 = this.props,
          socialNetworkUser = _this$props2.socialNetworkUser,
          user = _this$props2.user,
          planSelectDisabled = _this$props2.planSelectDisabled,
          darkMode = _this$props2.darkMode;

      var _ref5 = user || {},
          subscriptionLevelCode = _ref5.subscriptionLevelCode,
          subscriptionLevelMonthlyCostFormatted = _ref5.subscriptionLevelMonthlyCostFormatted;

      if (!subscriptionLevelMonthlyCostFormatted && defaultPlan) {
        subscriptionLevelCode = defaultPlan.code;
        subscriptionLevelMonthlyCostFormatted = defaultPlan.monthlyCostFormatted;
      }

      log.trace('user:', user);
      return /*#__PURE__*/React.createElement("div", {
        className: "wizardStepBase createAccount"
      }, (processing || formComplete) && /*#__PURE__*/React.createElement(Transition, {
        visible: processing || formComplete,
        animation: "scale",
        duration: 500
      }, /*#__PURE__*/React.createElement(Dimmer, {
        active: true,
        inverted: !darkMode
      }, /*#__PURE__*/React.createElement(Loader, {
        inverted: !darkMode
      }, "One Moment..."))), /*#__PURE__*/React.createElement(Header, {
        color: "grey",
        as: "h2",
        textAlign: "center"
      }, /*#__PURE__*/React.createElement(Divider, {
        hidden: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "stepTitle"
      }, socialNetworkUser ? /*#__PURE__*/React.createElement(React.Fragment, null, "Create your account.", /*#__PURE__*/React.createElement(Header.Subheader, null, /*#__PURE__*/React.createElement("br", null), "Excellent! Fill in or update the", /*#__PURE__*/React.createElement("br", null), "information we gathered to continue.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "Just two more steps and you're done!")) : /*#__PURE__*/React.createElement(React.Fragment, null, "Create your account.", /*#__PURE__*/React.createElement(Header.Subheader, null, /*#__PURE__*/React.createElement("br", null), "Use your email and create a password to use Enjoy", /*#__PURE__*/React.createElement("br", null), "with your favorite supported streaming services.", planSelectDisabled && subscriptionLevelCode !== FREE && subscriptionLevelMonthlyCostFormatted && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, getPlanCostLabel(user, defaultPlan).label1, getPlanCostLabel(user, defaultPlan).label2)))))), /*#__PURE__*/React.createElement(Divider, {
        hidden: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "subscribeStepContent"
      }, !processing && /*#__PURE__*/React.createElement(NewAccountForm, {
        template: "simple",
        includeHeader: false,
        onTermsClick: this.handleTermsClick,
        onPrivacyClick: this.handlePrivacyClick,
        onComplete: this.handleComplete,
        socialNetworkUser: socialNetworkUser,
        user: user,
        preRegistration: true,
        onUserAlreadyExists: this.handleUserAlreadyExists
      })), /*#__PURE__*/React.createElement(Divider, {
        hidden: true
      }), errors.length > 0 || errors.general ? /*#__PURE__*/React.createElement(Message, {
        size: "small",
        error: true,
        header: "Trouble with registration form...",
        list: _.concat(errors, errors.general, trace)
      }) : null);
    }
  }]);

  return Step2CreateAccount;
}(React.Component);

Step2CreateAccount.defaultProps = {
  forceComplete: false,
  socialNetworkUser: undefined,
  user: undefined,
  planCode: undefined,
  planSelectDisabled: false,
  darkMode: false,
  onFormComplete: function onFormComplete() {
    return null;
  },
  onFormSubmittedPendingValidation: function onFormSubmittedPendingValidation() {
    return null;
  }
};
export default Step2CreateAccount;